<script setup lang="ts">
withDefaults(defineProps<{
  w: string
}>(), {
  w: 'flex g-1 mw-92 w-full mx-auto justify-between',
})



const { $io } = useNuxtApp()
const fixed = computed(() => $io.headerFixed)
const mini = computed(() => $io.headerFixedMini)

</script>

<template>
<Section class="primary-header-container" :class="[{ fixed }, { mini }]" :w="w">
  <slot />
</Section>
</template>

<style lang="scss" scoped>
// This component could be responsibel for sizing
.primary-header-container {
  position: relative;
  z-index: 20;
  max-width: 100%;
  width:100%;
  height: 100%;

  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;

    @apply shadow-sm;
  }
}
</style>
